import React, { ReactNode } from 'react';
import { StyledPageTitle } from './index.styled';

type AppPageTitleProps = {
  prefix?: string | ReactNode;
  title: string | ReactNode;
  suffix?: string | ReactNode;
  className?: string;
  separator?: string;
  [x: string]: any;
};

const AppPageTitle: React.FC<AppPageTitleProps> = ({
  prefix,
  title,
  suffix,
  className,
  separator = ' of ',
  ...rest
}) => {
  return (
    <StyledPageTitle className={className} {...rest}>
      {prefix && <h2 className="page-title-prefix">{prefix}</h2>}
      {prefix && title && <h2 className="page-title-separator">{separator}</h2>}
      {title && <h2 className="page-title-main">{title}</h2>}
      {suffix && <h2 className="page-title-separator">{separator}</h2>}
      {suffix && <h2 className="page-title-suffix">{suffix}</h2>}
    </StyledPageTitle>
  );
};

export default AppPageTitle;
